// Rota ya da sihirbaz adımı değişince sayfa BAŞTAN başlasın.
//
// Kayan eleman PENCERENİN KENDİSİ: `.app` 100vh ama overflow-y vermiyor
// (`overflow-x: clip` + `overflow-y: visible` kombinasyonunda tarayıcı mutasyon
// uygulamaz), içerik belgeye taşar ve document scroll eder. Yine de ileride bir
// kapsayıcıya overflow verilirse bu yardımcı sessizce işlevsiz kalmasın diye bilinen
// kapsayıcılar da — yalnız GERÇEKTEN kaymışlarsa — sıfırlanır.
export default function scrollToTop() {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  try {
    window.scrollTo(0, 0);
  } catch {
    // jsdom / eski tarayıcı: aşağıdaki doğrudan atamalar yine de çalışır.
  }

  const { documentElement, body } = document;
  if (documentElement && documentElement.scrollTop) documentElement.scrollTop = 0;
  if (body && body.scrollTop) body.scrollTop = 0;

  [".app", ".main"].forEach((selector) => {
    const el = document.querySelector(selector);
    if (el && el.scrollTop) el.scrollTop = 0;
  });
}
